import { Controller } from "@hotwired/stimulus"

// Typeahead for the Forms & Tasks page search box. As the user types, it shows a
// dropdown of matching forms/tasks from the full catalog (catalog value, built
// server-side). Each suggestion is a real link, so selecting one is a normal
// Turbo visit to that item's detail page.
export default class extends Controller {
  static targets = ["input", "results", "container"]
  static values = { catalog: Array }

  connect() {
    this.highlighted = -1
    this.onOutsideClick = this.#onOutsideClick.bind(this)
    document.addEventListener("click", this.onOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.onOutsideClick)
  }

  update() {
    const query = this.inputTarget.value.trim().toLowerCase()
    if (query === "") return this.#hide()

    const matches = this.catalogValue
      .filter(item => item.title.toLowerCase().includes(query))
      .slice(0, 8)

    this.#render(matches)
    this.#show()
  }

  keydown(event) {
    if (this.resultsTarget.classList.contains("hidden")) return

    const links = this.#links()

    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        this.#moveHighlight(1, links)
        break
      case "ArrowUp":
        event.preventDefault()
        this.#moveHighlight(-1, links)
        break
      case "Enter":
        if (this.highlighted >= 0 && links[this.highlighted]) {
          event.preventDefault()
          links[this.highlighted].click()
        }
        break
      case "Escape":
        this.#hide()
        break
    }
  }

  #render(matches) {
    this.highlighted = -1
    this.resultsTarget.replaceChildren()

    if (matches.length === 0) {
      const empty = document.createElement("li")
      empty.className = "search-result search-result--empty"
      empty.textContent = "No matches"
      this.resultsTarget.appendChild(empty)
      return
    }

    matches.forEach(item => {
      const li = document.createElement("li")
      const link = document.createElement("a")
      link.href = item.url
      link.className = "search-result"

      const title = document.createElement("span")
      title.textContent = item.title

      const type = document.createElement("span")
      type.className = "search-result__type"
      type.textContent = item.type

      link.append(title, type)
      li.appendChild(link)
      this.resultsTarget.appendChild(li)
    })
  }

  #moveHighlight(delta, links) {
    if (links.length === 0) return
    this.highlighted = (this.highlighted + delta + links.length) % links.length
    links.forEach((link, i) => link.classList.toggle("is-highlighted", i === this.highlighted))
  }

  #links() {
    return Array.from(this.resultsTarget.querySelectorAll("a.search-result"))
  }

  #show() {
    this.resultsTarget.classList.remove("hidden")
  }

  #hide() {
    this.resultsTarget.classList.add("hidden")
    this.highlighted = -1
  }

  #onOutsideClick(event) {
    if (!this.containerTarget.contains(event.target)) this.#hide()
  }
}
